import React, {useEffect, useState} from "react";
import {Accordion, AccordionSummary, Button, ButtonGroup, Slider, Typography} from "@mui/material";
import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import {ExpandMore} from "@mui/icons-material";

const minDistance = 1

interface SliderFilterProps {
    value: [number, number],
    setValue: (value: [number, number]) => void,
    title: string,
    unit?: string,
    min?: number,
    max?: number,
}

export default observer(function SliderFilter({value, setValue, title, unit='', min=0, max=100}: SliderFilterProps){

    const handleChange = (
        event: Event,
        newValue: number | number[],
        activeThumb: number,
    ) => {
        if (!Array.isArray(newValue)) {
            return;
        }

        if (activeThumb === 0) {
            setValue([Math.min(newValue[0], value[1] - minDistance), value[1]]);
        } else {
            setValue([value[0], Math.max(newValue[1], value[0] + minDistance)]);
        }
    };


    return (
        <Accordion variant={'outlined'}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <Slider
                getAriaLabel={() => 'Minimum distance'}
                value={value}
                onChange={handleChange}
                valueLabelDisplay="auto"
                disableSwap
                max={max}
                min={min}
                valueLabelFormat={(value, index) => `${value} ${unit}`}
                color={'secondary'}
                sx={{width: '80%'}}
            />
        </Accordion>
    )
})